<div class="container d-flex flex-column pt-0 pe-3 pb-3 ps-3">
  <div class="header d-flex flex-row justify-content-between">
    <div>
      <ng-content select=".component-header"> </ng-content>
    </div>
    <div class="button-container pb-2">
      <button type="button" class="btn btn-sm border border-secondary-subtle rounded-1" (click)="fileInput.click()">
        <i
          class="fas fa-cloud-upload-alt text-primary"
          data-test-selector="select-file-button"
        ></i
        >&nbsp;Select File
      </button>

      <span class="position-absolute invisible m-0 border-0 p-0 w-0 h-0 overflow-hidden">
        <input
          data-test-selector="file-uploader"
          type="file"
          (change)="onFileChange($event)"
          accept="{{ allowedMimeTypes }}"
          name="files"
          [multiple]="allowMultiple"
          #fileInput
        />
      </span>
    </div>
  </div>
  <div
    class="content text-primary d-flex flex-row rounded-2"
    ng2FileDrop
    (onFileDrop)="dropped($event)"
    [uploader]="uploader"
    (click)="fileInput.click()"
  >
    <div *ngIf="!currentFileCount" class="no-file-present d-flex flex-row align-items-center justify-content-center">
      <div class="d-flex align-items-baseline">
        <i class="d-flex text-primary fas fa-cloud-upload-alt fa-4x"> </i>
        <h4 class="text-primary" data-test-selector="drag-and-drop-file-text">
          &nbsp;Drag & Drop your file
        </h4>
      </div>
    </div>

    <div *ngIf="currentFileCount" class="file-present p-3">
      <ng-content></ng-content>
    </div>
  </div>
</div>
